import Swiper from 'swiper';

export default {
  init() {
    
    /* Scroll to main
    ---------------------------------------------------------------------------------------------------- */
    
    $('.trigger-scroll-to-main').click(function(e){
      e.preventDefault();
      
      var offset = 0; //-($('#header').height() + $('.home-section--hero-unit .bottom').height());
      $(window).scrollTo($('#main'), 500, {offset:offset});
      
    });

    /* Slider
    ---------------------------------------------------------------------------------------------------- */
  
    $('.slider--hero').on('initSlider', function(){
  
      var el = $(this), 
          sliderEl = new Swiper($(el), {
              pagination: {
                el: $('.swiper-pagination', el),
                type: 'bullets',
                clickable: true,
              },
              autoplay: {
                delay: 3000,
              },
              speed: 1000,
              loop: true,
              effect: 'fade',
              autoHeight: true,
              //parallax: true,
              slidesPerView: 1,
              spaceBetween: 0, 
              runCallbacksOnInit: true,
              onSlideChangeStart: function(swiper) {
                console.log('onSlideChangeStart', swiper);
              },
              onReachEnd: function(swiper) {
                console.log('onReachEnd', swiper);
              },
              onSliderMove: function (swiper, event) {
                console.log('mueve el swipper', swiper, event);
              },
              onTransitionEnd: function () {
                console.log('transitionEnd');
              },
          });
      

      sliderEl.on('beforeSlideChangeStart', function(swiper){ // eslint-disable-line
        //console.log('beforeSlideChangeStart', swiper);
      });
      
      sliderEl.on('beforeTransitionStart', function(swiper){ // eslint-disable-line
        $(el).addClass('is-sliding');
      });
      
      sliderEl.on('transitionEnd', function(swiper){ // eslint-disable-line
        $(el).removeClass('is-sliding');
      });
      
  
    }); //.trigger('initSlider');


  },
  finalize() {

    setTimeout(function() {
      $('.slider--hero').trigger('initSlider');
    }, 500);

  },
};



// WEBPACK FOOTER //
// ./scripts/routes/home.js